module.exports = __webpack_public_path__ + "../static/img/urls-icon.24745c49.png";